import api from '../../api/axiosInstance';

export const getWebhookStats = () => api.get('/chartink-webhook/stats');

export const getWebhookAlerts = () => api.get('/chartink-webhook/alerts');

export const getWebhookAlert = (id) => api.get(`/chartink-webhook/alerts/${id}`);

export const createWebhookAlert = (body) => api.post('/chartink-webhook/alerts', body);

export const updateWebhookAlert = (id, body) => api.patch(`/chartink-webhook/alerts/${id}`, body);

export const rotateWebhookToken = (id) => api.post(`/chartink-webhook/alerts/${id}/rotate-token`);

export const deleteWebhookAlert = (id, deleteEvents = false) =>
  api.delete(`/chartink-webhook/alerts/${id}`, { params: { deleteEvents } });

export const getWebhookEvents = (params) => api.get('/chartink-webhook/events', { params });

export const getWebhookEvent = (id) => api.get(`/chartink-webhook/events/${id}`);

export const reprocessWebhookEvent = (id) => api.post(`/chartink-webhook/events/${id}/reprocess`);

export const deleteWebhookEvent = (id) => api.delete(`/chartink-webhook/events/${id}`);

export const bulkDeleteWebhookEvents = (body) => api.post('/chartink-webhook/events/bulk-delete', body);

export const purgeWebhookEventsBefore = (body) => api.post('/chartink-webhook/events/purge-before', body);
